import { render, staticRenderFns } from "./PwdModify.vue?vue&type=template&id=f9fa51c6&"
import script from "./PwdModify.vue?vue&type=script&lang=js&"
export * from "./PwdModify.vue?vue&type=script&lang=js&"
import style0 from "./PwdModify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports